import { useContext, useEffect, useState } from "react";
import { AutocheckContext } from "_+_Portal/_-_Autocheckin/context/Provider";
import { ContainerPuntoControl } from "./localStyle";
import {
  wsGetPuntoControlTexto,
  wsPostTrazaPuntoControl,
} from "_+_Portal/_-_Autocheckin/context/action/puntoControl";
import LayoutPasos from "_+_Portal/_-_Autocheckin/components/genericos/LayoutPasos/LayoutPasos";
import puntoControlImage from "_+_Portal/assets/images/generico/puntoControl.png";
import { setPaso } from "_+_Portal/_-_Autocheckin/context/action/paso";
import { PortalContext } from "_+_Portal/context/Provider";
import { GlobalContext } from "global/context/Provider";

const PuntoControl = ({ turnoActual }) => {
  //#region --------- context ---------------
  const {
    puntoControlState,
    turnosSeleccionadosState,
    pasoDispatch,
    textosAutoCheckinState,
  } = useContext(AutocheckContext);
  const { selectDropDownState } = useContext(PortalContext);
  const { authState } = useContext(GlobalContext);
  //#endregion  ----- context ---------------
  //#region  ----------- constants ---------------
  const dataViewDefault = {
    nombre: "Punto de control",
    descripcion: "Por favor acercate al punto de control. ¡Gracias!",
    verLogo: true,
  };
  const [dataView, setDataView] = useState(dataViewDefault);
  const listTurnosSeleccionado =
    turnosSeleccionadosState.turnosSeleccionados.data;
  const pacienteElegido =
    selectDropDownState.selectDropDown.selectGlobal.pacienteElegido?.paciente;

  const pacienteCodigo = pacienteElegido
    ? pacienteElegido.codigo
    : authState.auth.data.paciente.codigo;

  let config = localStorage.getItem("config");
  let sectorTurno = JSON.parse(config).sectorTurno;
  const turno = listTurnosSeleccionado[turnoActual];
  const idTipo = puntoControlState.puntoControl.idTipo;
  const textosAutoCheckin = textosAutoCheckinState?.textosAutoCheckin?.data;
  const puntoControlText = textosAutoCheckin?.puntoControl;
  const puntoControlEfectivoText = textosAutoCheckin?.puntoControlEfectivo;
  //#endregion --------- constants ---------------
  //#region  ----------- funciones ---------------
  const nextStepPost = (isCorrect) => {
    if (isCorrect) {
      if (puntoControlState.puntoControl.idTipo > 0 && turno) {
        wsGetPuntoControlTexto(
          puntoControlState.puntoControl.idTipo,
          turno.idRecepcion,
          turno.idCentro
        )((isCorrect, data) => nextStepGet(isCorrect, data));
      } else {
        setDataView(dataViewDefault);
      }
    }
  };
  const nextStepGet = (isCorrect, data) => {
    if (isCorrect) {
      setDataView(data);
    } else {
      if (puntoControlText) {
        setDataView(puntoControlText);
      } else {
        setDataView(idTipo === 7 ? puntoControlEfectivoText : dataViewDefault);
      }
    }
  };
  const handleVolver = () => {
    setPaso("Home")(pasoDispatch);
  };
  //#endregion --------- funciones ---------------
  //#region  ----------- useEffect ---------------
  useEffect(() => {
    const fecha = new Date().toISOString();
    const dto = {
      idtipo: idTipo,
      fechaalta: fecha,
      idpaciente: Number(pacienteCodigo),
      idsectoralta: Number(sectorTurno),
      idterminal: -1,
      idturno: turno?.idturno ? turno.idturno : -1,
      idprotocolo: turno?.idProtocolo ? turno.idProtocolo : -1,
    };
    wsPostTrazaPuntoControl(dto)(nextStepPost);
  }, []);
  //#endregion  -------- useEffect ---------------

  return (
    <LayoutPasos
      volverTo={"/autocheckin/resumen"}
      handleClick={handleVolver}
      type={"no-circle"}
      title={"PUNTO DE CONTROL"}
    >
      <ContainerPuntoControl
        initial={{ opacity: 0, y: -90 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: 100 }}
        transition={{ duration: 0.4 }}
      >
        <h1 dangerouslySetInnerHTML={{ __html: dataView?.nombre }} />
        <span dangerouslySetInnerHTML={{ __html: dataView?.descripcion }} />
        {dataView?.verLogo ? (
          <img src={puntoControlImage} alt="Icono ilustrativo" />
        ) : (
          ""
        )}
        <button onClick={handleVolver} className="danger">
          Salir
        </button>
      </ContainerPuntoControl>
    </LayoutPasos>
  );
};

export default PuntoControl;
